import React from 'react';
import Edit from '../../componentes/edit/edit-dialog';
import { autobind } from 'core-decorators';
import { Schema } from '../../utils/form';
import Slider from './slider';
import Panel from '../../componentes/panel';
import LucideIcon from '../../componentes/lucide-icon';
import Input from '../../componentes/input';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import TipoValorFaixaLookup from '../../lookups/tipo-valor-faixa';
import { FormattedMessage, injectIntl } from 'react-intl';
import Confirm from '../../componentes/message-box/confirm';
import ContentManager from '../../componentes/content-manager';
import http from 'src/services/httpService';
import errorHandler from '../../utils/error-handler';
import ReprocessarDialog from './reprocessarFarois';
import Checkbox from 'src/componentes/checkbox';
import { MODULOS } from 'src/utils/constants';
import CasasDecimaisLookup from 'src/lookups/CasasDecimaisLookup';
import { capitalizeFirstLetter } from 'src/utils/string';

let schema = Schema.object({
  descricao: Schema.string()
    .label(<FormattedMessage id="descricao" />)
    .required(),
  tipoValorMelhorIgual: Schema.string().label(
    <FormattedMessage id="label.tipoValor" />
  ),
  tipoValorMelhorParaBaixo: Schema.string().label(
    <FormattedMessage id="label.tipoValor" />
  ),
  tipoValorMelhorParaCima: Schema.string().label(
    <FormattedMessage id="label.tipoValor" />
  ),
  faixaPadrao: Schema.string().label(
    <FormattedMessage id="label.faixaPadrao" />
  ),
  faixaIgual: Schema.array().label(<FormattedMessage id="label.faixaIgual" />),
  faixaMaior: Schema.array().label(<FormattedMessage id="label.faixaMaior" />),
  faixaMenor: Schema.array().label(<FormattedMessage id="label.faixaMenor" />),
  melhorIgual: Schema.array().label(''),
  melhorParaBaixo: Schema.array().label(''),
  melhorParaCima: Schema.array().label(''),
  idIntegracao: Schema.string()
    .label(<FormattedMessage id="idIntegracao" />)
    .required(),
  interpolarValoresFaixaMelhorIgual: Schema.string().label(
    <FormattedMessage id="label.interpolarValoresFaixa" />
  ),
  usarPontoFaixaResultadoMelhorIgual: Schema.string().label(
    <FormattedMessage id="usarPontoFaixaResultadoFaixaFarol" />
  ),
  interpolarValoresFaixaMelhorParaBaixo: Schema.string().label(
    <FormattedMessage id="label.interpolarValoresFaixa" />
  ),
  usarPontoFaixaResultadoMelhorParaBaixo: Schema.string().label(
    <FormattedMessage id="usarPontoFaixaResultadoFaixaFarol" />
  ),
  interpolarValoresFaixaMelhorParaCima: Schema.string().label(
    <FormattedMessage id="label.interpolarValoresFaixa" />
  ),
  usarPontoFaixaResultadoMelhorParaCima: Schema.string().label(
    <FormattedMessage id="usarPontoFaixaResultadoFaixaFarol" />
  ),
  casasDecimais: Schema.string()
    .label(<FormattedMessage id="casasDecimais" />)
    .required(),
});

@autobind
class FormEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: '1',
    };
  }

  handleCasasDecimaisChange(value) {
    this.props.model.getModel('casasDecimais').requestChange(value.id);
  }

  handleSelect(activeKey) {
    this.setState({
      activeKey: this.state.activeKey === activeKey ? 0 : activeKey,
    });
  }

  render() {
    let {
      modulosComprados,
      model,
      exibirApenasValorAbsoluto = false,
      faixaIndicadorRisco = false,
      intl,
    } = this.props;

    const hasRVModule = modulosComprados.find(
      (m) => m.id === MODULOS.REMUNERACAO_VARIAVEL && m.ativo
    );

    return (
      <div>
        <Row>
          <Col md={3}>
            <Input model={model.getModel('idIntegracao')} required />
          </Col>
          <Col md={6}>
            <Input model={model.getModel('descricao')} required />
          </Col>
          <Col md={3} style={{ marginTop: '-2x' }}>
            <CasasDecimaisLookup
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'casasDecimais' })
                ),
                value: model.getModel('casasDecimais').value,
                requestChange: this.handleCasasDecimaisChange,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel
              header={
                <div>
                  <span>
                    <FormattedMessage id="faixaDeFarol" />
                    <LucideIcon
                      icon={
                        model.getModel('melhorParaCima').value &&
                        model.getModel('melhorParaCima').value.icone
                      }
                    />
                  </span>
                </div>
              }
              eventkey="1"
            >
              <Slider
                key={model.getModel('casasDecimais').value}
                melhor={model.getModel('melhorParaCima')}
                model={model.getModel('faixaMaior')}
                tipoValor={model.getModel('tipoValorMelhorParaCima')}
                usarPontoFaixaResultado={
                  hasRVModule &&
                  model.getModel('usarPontoFaixaResultadoMelhorParaCima')?.value
                }
                interpolarValoresFaixa={
                  hasRVModule &&
                  model.getModel('interpolarValoresFaixaMelhorParaCima')?.value
                }
                faixaIndicadorRisco={faixaIndicadorRisco}
                casasDecimais={model.getModel('casasDecimais').value}
              />
              <Row>
                <Col md={6}>
                  <TipoValorFaixaLookup
                    disabled={exibirApenasValorAbsoluto}
                    model={model.getModel('tipoValorMelhorParaCima')}
                  />
                </Col>
              </Row>
              {hasRVModule && (
                <Row>
                  <Col md={12}>
                    <Checkbox
                      model={model.getModel(
                        'usarPontoFaixaResultadoMelhorParaCima'
                      )}
                      style={{ marginTop: 5 }}
                    />
                  </Col>
                </Row>
              )}
              {hasRVModule &&
                model.getModel('usarPontoFaixaResultadoMelhorParaCima')
                  ?.value && (
                  <Row>
                    <Col md={12}>
                      <Checkbox
                        model={model.getModel(
                          'interpolarValoresFaixaMelhorParaCima'
                        )}
                        style={{ marginTop: 5 }}
                      />
                    </Col>
                  </Row>
                )}
            </Panel>
          </Col>
          <Col md={12}>
            <Panel
              header={
                <div>
                  <span>
                    <FormattedMessage id="faixaDeFarol" />
                    <LucideIcon
                      icon={
                        model.getModel('melhorParaBaixo').value &&
                        model.getModel('melhorParaBaixo').value.icone
                      }
                    />
                  </span>
                </div>
              }
              eventkey="2"
            >
              <Slider
                key={model.getModel('casasDecimais').value}
                melhor={model.getModel('melhorParaBaixo')}
                model={model.getModel('faixaMenor')}
                tipoValor={model.getModel('tipoValorMelhorParaBaixo')}
                faixaIndicadorRisco={faixaIndicadorRisco}
                usarPontoFaixaResultado={
                  hasRVModule &&
                  model.getModel('usarPontoFaixaResultadoMelhorParaBaixo')
                    ?.value
                }
                interpolarValoresFaixa={
                  hasRVModule &&
                  model.getModel('interpolarValoresFaixaMelhorParaBaixo')?.value
                }
                casasDecimais={model.getModel('casasDecimais').value}
              />
              <Row>
                <Col md={6}>
                  <TipoValorFaixaLookup
                    disabled={exibirApenasValorAbsoluto}
                    model={model.getModel('tipoValorMelhorParaBaixo')}
                  />
                </Col>
              </Row>
              {hasRVModule && (
                <Row>
                  <Col md={12}>
                    <Checkbox
                      model={model.getModel(
                        'usarPontoFaixaResultadoMelhorParaBaixo'
                      )}
                      style={{ marginTop: 27 }}
                    />
                  </Col>
                </Row>
              )}
              {hasRVModule &&
                model.getModel('usarPontoFaixaResultadoMelhorParaBaixo')
                  ?.value && (
                  <Row>
                    <Col md={12}>
                      <Checkbox
                        model={model.getModel(
                          'interpolarValoresFaixaMelhorParaBaixo'
                        )}
                        style={{ marginTop: 5 }}
                      />
                    </Col>
                  </Row>
                )}
            </Panel>
          </Col>
          <Col md={12}>
            <Panel
              header={
                <div>
                  <span>
                    <FormattedMessage id="faixaDeFarol" />
                    <LucideIcon
                      icon={
                        model.getModel('melhorIgual').value &&
                        model.getModel('melhorIgual').value.icone
                      }
                    />
                  </span>
                </div>
              }
              eventkey="3"
            >
              <Slider
                key={model.getModel('casasDecimais').value}
                melhor={model.getModel('melhorIgual')}
                model={model.getModel('faixaIgual')}
                tipoValor={model.getModel('tipoValorMelhorIgual')}
                faixaIndicadorRisco={faixaIndicadorRisco}
                usarPontoFaixaResultado={
                  hasRVModule &&
                  model.getModel('usarPontoFaixaResultadoMelhorIgual')?.value
                }
                interpolarValoresFaixa={
                  hasRVModule &&
                  model.getModel('interpolarValoresFaixaMelhorIgual')?.value
                }
                casasDecimais={model.getModel('casasDecimais').value}
              />
              <Row>
                <Col md={6}>
                  <TipoValorFaixaLookup
                    disabled={exibirApenasValorAbsoluto}
                    model={model.getModel('tipoValorMelhorIgual')}
                  />
                </Col>
              </Row>
              {hasRVModule && (
                <Row>
                  <Col md={12}>
                    <Checkbox
                      model={model.getModel(
                        'usarPontoFaixaResultadoMelhorIgual'
                      )}
                      style={{ marginTop: 5 }}
                    />
                  </Col>
                </Row>
              )}
              {hasRVModule &&
                model.getModel('usarPontoFaixaResultadoMelhorIgual')?.value && (
                  <Row>
                    <Col md={12}>
                      <Checkbox
                        model={model.getModel(
                          'interpolarValoresFaixaMelhorIgual'
                        )}
                        style={{ marginTop: 5 }}
                      />
                    </Col>
                  </Row>
                )}
            </Panel>
          </Col>
        </Row>
      </div>
    );
  }
}

@autobind
class FaixaFarolEdit extends React.Component {
  handleSave(model, close) {
    ContentManager.addContent(
      <Confirm
        labelCancel={<FormattedMessage id="label.reprocessar" />}
        labelConfirm={<FormattedMessage id="label.salvar" />}
        message={
          <FormattedMessage id="desejaReprocessarFaroisItenVinculadoFaixa" />
        }
        handleConfirm={this.handleSaveConfirmFaixa.bind(this, model, close)}
        handleCancel={this.handleConfirmData.bind(this, model, close)}
      />
    );
  }

  handleConfirmData(model, close) {
    ContentManager.addContent(
      <ReprocessarDialog intl={this.props.intl} close={close} model={model} />
    );
  }

  handleSaveConfirmFaixa(model, close) {
    http
      .post(`/FaixaFarol/Save`, {
        model: model,
        parameters: { ...this.props.parameters },
      })
      .then(() => {
        close();
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  render() {
    return (
      <Edit
        url="/FaixaFarol"
        title="faixaDeFarol"
        formComponent={FormEdit}
        schema={schema}
        handleSave={this.handleSave}
        width="80%"
        height="90%"
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    modulosComprados: state.user.licenca.modulos,
  };
}

export default injectIntl(connect(mapStateToProps)(FaixaFarolEdit));
